// Full premium report content for Alexei Petrov (15.08.1992, 14:30, Moscow)
// Sun: Leo, Moon: Scorpio, Asc: Sagittarius

export const INTRO_CONTENT = {
  title: 'Введение',
  whatIsNatalChart: `Натальная карта (от лат. natalis — «относящийся к рождению») — это астрономическая карта неба, зафиксированная на момент вашего рождения. Она представляет собой точную проекцию положений Солнца, Луны и планет Солнечной системы относительно знаков зодиака и домов гороскопа в конкретный момент времени и в конкретной точке на Земле.

По сути, натальная карта — это ваш космический паспорт. Она не определяет вашу судьбу жёстко, но описывает набор энергий, талантов, склонностей и потенциальных вызовов, с которыми вы пришли в этот мир. Это карта вашего внутреннего ландшафта — психологического, эмоционального и духовного.

Каждый элемент карты несёт определённый смысл. Планеты символизируют различные функции психики (воля, эмоции, мышление, любовь, действие). Знаки зодиака показывают стиль, в котором эти функции проявляются. Дома гороскопа указывают на конкретные сферы жизни, где эти энергии будут наиболее активны. Аспекты (углы между планетами) описывают внутренние диалоги и конфликты между различными частями вашей личности.`,

  howItWorks: `Астрология основана на принципе «как наверху, так и внизу» (Гермес Трисмегист). Это не означает, что планеты физически влияют на вас. Скорее, астрология работает как язык символов — универсальная система описания архетипов и циклов, которая помогает человеку лучше понять себя.

Современная психологическая астрология (которая лежит в основе этого отчёта) не предсказывает конкретные события. Она описывает внутренние паттерны, мотивации и потенциалы. Вы всегда остаётесь хозяином своей жизни и своих решений. Натальная карта — это не приговор, а навигатор.

Расчёт натальной карты основан на точных астрономических данных — эфемеридах (таблицах положений небесных тел). Для точного расчёта необходимы три параметра: дата рождения, точное время рождения и место рождения. Время рождения особенно важно, так как оно определяет Асцендент (восходящий знак) и систему домов — без этих данных интерпретация будет неполной.`,

  howToRead: `Этот отчёт построен по принципу «от общего к частному». Мы начинаем с общего психологического портрета, затем углубляемся в каждую планету, дом и аспект. В конце мы синтезируем все данные в практические разделы: карьера, любовь, здоровье, кармические задачи.

Рекомендации по чтению:
• Не пытайтесь прочитать весь отчёт за один раз. Разделите чтение на несколько сессий.
• Начните с «Большой тройки» (Солнце, Луна, Асцендент) — это фундамент вашей личности.
• Обращайте внимание на повторяющиеся темы — если одна и та же тема всплывает в разных разделах, она особенно значима для вас.
• Некоторые описания могут показаться противоречивыми — это нормально. Человеческая психика многогранна, и натальная карта отражает эту сложность.
• Используйте отчёт как инструмент самопознания, а не как окончательный вердикт.`,
}

export const EXTENDED_SUN = {
  lifePurpose: `Ваша жизненная цель как человека с Солнцем во Льве — научиться быть подлинным лидером. Не тем, кто командует и подавляет, а тем, кто вдохновляет своим примером. Лев — это знак сердца, и ваша задача — жить из сердца, щедро делясь своим теплом, творчеством и энтузиазмом.

В молодости вы можете путать лидерство с доминированием, а признание — с одобрением. Зрелый Лев понимает, что истинное величие — это не корона на голове, а свет, который вы зажигаете в других людях. Ваш путь — от эгоцентричного «я хочу быть в центре внимания» к щедрому «я хочу, чтобы каждый нашёл свой свет».

Солнце в обители даёт вам огромный запас витальности. Вы буквально заряжаете пространство вокруг себя. Когда вы входите в комнату, температура повышается — не физически, но энергетически. Люди тянутся к вам, как растения к солнцу. Это и дар, и ответственность.`,

  dailyLife: `В повседневной жизни Солнце во Льве проявляется через потребность в самовыражении. Вы не можете долго оставаться в тени — вам физически необходимо творить, проявляться, получать обратную связь. Рутинная, монотонная работа без признания может буквально лишить вас жизненных сил.

Вы щедры в быту: любите угощать гостей, делать подарки, устраивать праздники. Ваш дом, скорее всего, обставлен со вкусом — вы цените качественные, красивые вещи. Вы не из тех, кто экономит на себе (хотя Венера в Раке может вносить коррективы в этот паттерн).

В дружбе вы верны и великодушны, но ожидаете уважения к своему статусу. Вы не терпите, когда вас перебивают, игнорируют или обесценивают. Предательство друга ранит вас глубоко, и вы способны полностью вычеркнуть человека из своей жизни, если он перешёл черту.`,

  inRelationships: `В романтических отношениях Солнце во Льве делает вас щедрым, страстным и требовательным партнёром. Вы любите красиво ухаживать, делать широкие жесты, удивлять. Но вы также ожидаете восхищения и благодарности в ответ. Партнёр, который воспринимает вашу щедрость как должное, быстро вас разочарует.

Вам важно гордиться своим партнёром. Вы подсознательно выбираете людей, которые усиливают ваш собственный образ. Это может быть как здоровым (выбор достойного, сильного партнёра), так и нездоровым (выбор «трофейного» партнёра ради статуса).`,
}

export const EXTENDED_MOON = {
  emotionalPatterns: `Луна в Скорпионе создаёт один из самых интенсивных эмоциональных паттернов в астрологии. Ваши чувства никогда не бывают поверхностными. Вы либо любите до безумия, либо ненавидите всей душой. Середины для вас не существует.

Этот паттерн формируется в раннем детстве. Часто Луна в Скорпионе указывает на то, что в семье были темы контроля, секретов, эмоционального давления или трансформации. Возможно, ваша мать была сильной, но эмоционально сложной женщиной. Или в семье были события, которые научили вас рано понимать, что мир — не всегда безопасное место.

В результате вы развили мощный защитный механизм: вы научились скрывать свои истинные чувства, сканировать окружающих на предмет угрозы и контролировать ситуацию. Это делает вас невероятно проницательным, но может мешать в близких отношениях, где нужна уязвимость.`,

  motherRelation: `Отношения с матерью (или материнской фигурой) — ключевая тема Луны в Скорпионе. Эти отношения, скорее всего, были интенсивными, сложными и трансформирующими. Возможно, ваша мать была властной, проницательной, эмоционально требовательной. Или между вами существовала невербальная, почти телепатическая связь.

Луна в 12 доме добавляет к этому тему скрытности и жертвенности. Возможно, мать что-то скрывала, или вы чувствовали её боль и несли её как свою собственную. Проработка отношений с матерью — один из ключевых психологических процессов для вас. Это не значит, что нужно обвинять или отвергать — это значит осознать паттерны и освободиться от бессознательного повторения.`,

  hiddenNeeds: `Ваши скрытые эмоциональные потребности (которые вы, возможно, не осознаёте или стесняетесь признать):
  
Потребность в абсолютной честности. Вы не выносите лжи, даже «белой». Если вы чувствуете, что от вас что-то скрывают, это вызывает глубокую тревогу и подозрительность.

Потребность в эмоциональной интенсивности. Спокойная, ровная жизнь без драмы может казаться вам пресной. Вы подсознательно ищете (или создаёте) кризисы, чтобы чувствовать себя живым.

Потребность в контроле. Вы чувствуете себя в безопасности, когда контролируете ситуацию. Отпустить контроль — один из ваших главных жизненных уроков.

Потребность в трансформации. Вы не можете стоять на месте. Вам нужно постоянно углубляться, исследовать, разрушать старое и строить новое.`,
}

export const EXTENDED_MERCURY = {
  learningStyle: `Меркурий во Льве определяет ваш стиль мышления как творческий, масштабный и ориентированный на самовыражение. Вы учитесь лучше всего, когда материал подан ярко, с примерами и историями. Сухие таблицы и монотонные лекции — не ваш формат.

Ваш идеальный способ обучения — это преподавание. Когда вам нужно объяснить что-то другим, вы усваиваете материал в разы быстрее. Вы также хорошо учитесь через визуализацию, ролевые игры и творческие проекты.

Ваш ум склонен к обобщениям и масштабному мышлению. Вы видите «лес», но можете упускать «деревья». Детали и рутинная проверка фактов — не ваша сильная сторона. Вам лучше работать в паре с кем-то, кто силён в аналитике (Дева, Козерог).`,

  communicationStyle: `В общении вы — прирождённый оратор и рассказчик. Ваша речь яркая, эмоциональная, с жестами и мимикой. Вы умеете удерживать внимание аудитории и подавать информацию так, что она запоминается.

Однако есть и теневая сторона: вы можете быть категоричны в своих суждениях, не любите, когда вас перебивают, и склонны воспринимать интеллектуальные споры как личные нападки. Критика ваших идей = критика вас лично. Это важно осознать и проработать.

Соединение Солнца и Меркурия во Льве усиливает эти качества. Ваше мышление тесно связано с вашим эго. Когда вы говорите, вы не просто передаёте информацию — вы выражаете себя. Это делает вашу речь убедительной, но может создавать слепые зоны: вам трудно объективно оценить идею, если она противоречит вашему самоощущению.`,

  decisionMaking: `Решения вы принимаете быстро и уверенно. Вы доверяете своей интуиции и своему «внутреннему знанию» больше, чем анализу данных. Это часто работает в вашу пользу (особенно в творческих и лидерских ситуациях), но может подвести в финансовых или технических вопросах, где нужен холодный расчёт.

Приняв решение, вы редко его меняете. Это связано с фиксированной природой Льва и общей доминантой фиксированного креста в вашей карте. Вы можете воспринимать изменение решения как слабость, хотя иногда гибкость — это мудрость, а не слабость.`,
}

export const EXTENDED_VENUS = {
  loveLanguage: `Венера в Раке определяет ваш язык любви как заботу, эмоциональную поддержку и создание уюта. Вы выражаете любовь через:

• Приготовление еды для любимого человека
• Создание уютного, безопасного пространства
• Эмоциональную доступность и готовность выслушать
• Нежные прикосновения и объятия
• Заботу о здоровье и благополучии партнёра

Вы ожидаете того же в ответ. Партнёр, который эмоционально недоступен, холоден или не ценит домашний уют, будет вызывать у вас глубокое чувство незащищённости.

Интересный контраст: ваше Солнце во Льве хочет блеска, праздника и восхищения, а Венера в Раке хочет тихого вечера дома с любимым человеком, пледом и горячим чаем. Этот внутренний конфликт между «светской жизнью» и «домашним гнездом» — одна из ключевых тем вашей личности.`,

  aesthetics: `Ваши эстетические предпочтения формируются Венерой в Раке: вы тяготеете к уютному, тёплому, немного ностальгическому стилю. Вам нравятся натуральные материалы (дерево, хлопок, шерсть), мягкие цвета (кремовый, голубой, серебристый), винтажные вещи с историей.

В интерьере вы цените комфорт выше моды. Ваш дом — это ваша крепость, и вы вкладываете в него много души. Фотографии семьи, памятные вещи, мягкое освещение — всё это создаёт атмосферу, в которой вы чувствуете себя в безопасности.`,

  financialHabits: `Финансовое поведение Венеры в Раке характеризуется осторожностью и стремлением к накоплению. Деньги для вас — это не статус (как для Льва) и не свобода (как для Стрельца), а безопасность. Вы чувствуете себя спокойно, когда у вас есть финансовая подушка.

Вы склонны к эмоциональным покупкам, особенно когда чувствуете себя незащищённым или одиноким. «Заедание» стресса или «шопинг-терапия» — возможные паттерны, которые стоит отслеживать.

При этом вы щедры по отношению к семье и близким. Вы готовы отдать последнее ради благополучия тех, кого любите. Это прекрасное качество, но важно не забывать о собственных финансовых границах.`,
}

export const EXTENDED_MARS = {
  conflictStyle: `Марс в Близнецах определяет ваш стиль конфликта как вербальный, интеллектуальный и стратегический. Вы не из тех, кто лезет в драку кулаками. Ваше оружие — слово, сарказм, ирония и безупречная логика.

В конфликте вы способны мгновенно найти слабое место оппонента и нанести точный словесный удар. Это делает вас грозным противником в спорах, но может разрушать отношения, если вы не контролируете свой острый язык.

Проблема Марса в Близнецах — это рассеивание энергии. Вы можете начать спор, переключиться на другую тему, вернуться к первой, затем вспомнить обиду трёхлетней давности — всё за одну ссору. Партнёру может быть сложно уследить за ходом вашей мысли.`,

  ambitionStyle: `Ваши амбиции (Марс) реализуются через интеллект, коммуникацию и многозадачность (Близнецы). Вы не из тех, кто годами копает одну шахту. Вы скорее будете вести несколько проектов параллельно, переключаясь между ними по мере интереса.

Это может быть как преимуществом (широкий кругозор, гибкость, множество навыков), так и недостатком (ни одно дело не доведено до конца, поверхностность). Ваша задача — научиться фокусироваться. Фиксированная доминанта вашей карты (5 планет в фиксированных знаках) помогает в этом, но Марс в мутабельном знаке всё равно тянет вас в сторону разнообразия.

Идеальная карьерная стратегия для вас — найти область, которая сама по себе требует многозадачности и коммуникации: журналистика, маркетинг, преподавание, IT-менеджмент, консалтинг.`,

  physicalEnergy: `Физическая энергия Марса в Близнецах — нервная, подвижная, но не особенно выносливая. Вы быстро загораетесь, но так же быстро устаёте, если занятие становится монотонным. Вам подходят виды спорта, требующие ловкости, скорости и интеллекта: теннис, бадминтон, фехтование, танцы, боевые искусства с техническим уклоном.

Ваша нервная система — ваше слабое место. Марс в Близнецах может давать бессонницу, нервное перенапряжение, проблемы с руками и лёгкими. Важно регулярно «разгружать» голову: медитация, прогулки, дыхательные практики.`,
}

export const EXTENDED_JUPITER = `Юпитер в Деве — это парадоксальное положение. Юпитер — планета расширения, щедрости и масштабного мышления. Дева — знак сужения, детализации и скромного служения. Юпитер здесь находится в изгнании, что не означает «плохо», но означает «нестандартно».

Ваша удача приходит не через везение, а через компетентность. Вы расширяете свои горизонты не через авантюры, а через совершенствование навыков. Ваша философия жизни практична: «Бог помогает тем, кто помогает себе сам».

Юпитер в 10 доме (карьера) усиливает профессиональные амбиции. Вы способны достичь высокого социального положения, но путь к нему будет лежать через экспертность, а не через связи или удачу. Вы — тот человек, которого повышают за реальные заслуги.

Теневая сторона: склонность к перфекционизму, критичность к себе и другим, трудоголизм. Юпитер в Деве может давать проблемы с пищеварением на нервной почве.`

export const EXTENDED_SATURN = `Сатурн в Водолее — одно из самых сильных положений Сатурна (обитель). Это говорит о том, что вы серьёзно относитесь к темам свободы, равенства, технологий и коллективного сознания.

Ваш главный жизненный урок — научиться быть частью группы, не теряя индивидуальности. Сатурн здесь требует от вас ответственного подхода к дружбе, социальным связям и общественной деятельности. Вы не можете просто «тусоваться» — вам нужно строить структуры, которые объединяют людей.

Сатурн в 3 доме (общение, обучение) добавляет серьёзность к вашему мышлению. Вы можете быть медленным учеником в юности, но с возрастом ваш интеллект становится всё более глубоким и структурированным. Вы учитесь всю жизнь и со временем становитесь настоящим экспертом в своей области.

Возможные трудности: чувство одиночества в толпе, страх быть «не таким как все», сложности с выражением своих идей в молодости. После 29 лет (первый возврат Сатурна) эти темы начинают прорабатываться, и к 35-40 годам вы обретаете уверенность в своей уникальности.`

export const OUTER_PLANETS_EXTENDED = {
  uranus: `Уран в Козероге (1988–1995) — это поколение, которое пришло реформировать устаревшие структуры: государственные институты, корпорации, образовательные системы. Вы интуитивно понимаете, как работают иерархии, и знаете, как их трансформировать изнутри.

Уран во 2 доме (финансы, ценности) лично для вас означает нестандартный подход к деньгам. Вы можете зарабатывать необычными способами: через технологии, интернет, криптовалюту, фриланс. Ваши финансы могут быть нестабильными — периоды изобилия чередуются с неожиданными потерями. Важно иметь несколько источников дохода.`,

  neptune: `Нептун в Козероге (1984–1998) — поколение, которое привносит духовность и интуицию в материальный мир. Вы не верите в «чистый бизнес без души» — вам важно, чтобы работа имела высший смысл.

Нептун во 2 доме может давать размытые финансовые границы: вы можете быть слишком щедрым, давать деньги в долг без возврата или не отслеживать свои расходы. С другой стороны, этот аспект может давать доход через творчество, музыку, кино, духовные практики или благотворительность.`,

  pluto: `Плутон в Скорпионе (1983–1995) — это поколение максимальной трансформационной силы. Плутон здесь находится в своей обители, что делает его энергию особенно мощной. Ваше поколение пришло, чтобы разрушить табу, исследовать глубины человеческой психики и трансформировать отношение общества к темам смерти, сексуальности, власти и денег.

Плутон в 12 доме (подсознание) лично для вас означает огромную скрытую психическую силу. Вы можете быть прирождённым психологом, целителем или исследователем паранормального. Ваши сны могут быть пророческими. Вы способны трансформировать не только себя, но и окружающих — часто просто своим присутствием.

Теневая сторона: склонность к навязчивым мыслям, страхи, связанные с потерей контроля, возможные психосоматические заболевания. Важно регулярно «чистить» своё подсознание через терапию, медитацию или творчество.`,
}

export const HOUSES_DETAILED = [
  {
    num: 1,
    sign: 'Стрелец',
    theme: 'Личность и самовыражение',
    planets: [],
    text: 'Первый дом в Стрельце определяет вашу внешнюю подачу как оптимистичную, открытую и философскую. Вы производите впечатление человека, который знает, куда идёт, и приглашает других присоединиться к путешествию. Ваше тело, скорее всего, крупное или высокое, с широкими жестами и открытой позой.',
  },
  {
    num: 2,
    sign: 'Козерог',
    theme: 'Финансы и ценности',
    planets: ['Уран', 'Нептун'],
    text: 'Второй дом в Козероге с Ураном и Нептуном — сложная финансовая картина. С одной стороны, Козерог даёт вам серьёзное, ответственное отношение к деньгам. С другой — Уран вносит нестабильность и неожиданные повороты, а Нептун размывает границы. Ваш путь к финансовой стабильности лежит через инновации (Уран) с практическим применением (Козерог) и творческим подходом (Нептун).',
  },
  {
    num: 3,
    sign: 'Водолей',
    theme: 'Общение и мышление',
    planets: ['Сатурн'],
    text: 'Третий дом в Водолее с Сатурном говорит о серьёзном, структурированном подходе к общению и обучению. В юности вам могло быть сложно выражать свои мысли или общаться со сверстниками. С возрастом вы становитесь всё более красноречивым и авторитетным в интеллектуальной сфере. Вы мыслите нестандартно, но выражаете свои идеи чётко и структурированно.',
  },
  {
    num: 4,
    sign: 'Рыбы',
    theme: 'Дом, семья, корни',
    planets: [],
    text: 'Четвёртый дом в Рыбах указывает на чувствительную, возможно, хаотичную домашнюю обстановку в детстве. Ваш дом мог быть местом, где границы были размыты: эмоциональные, физические или психологические. Во взрослой жизни вы стремитесь создать дом как убежище — тихое, красивое, наполненное музыкой и духовностью.',
  },
  {
    num: 5,
    sign: 'Овен',
    theme: 'Творчество, дети, романтика',
    planets: [],
    text: 'Пятый дом в Овне даёт вам страстный, импульсивный подход к творчеству и романтике. Вы влюбляетесь быстро и ярко. В творчестве вы — инициатор, который любит начинать новые проекты. С детьми вы энергичны и игривы, но можете быть нетерпеливы.',
  },
  {
    num: 6,
    sign: 'Телец',
    theme: 'Работа и здоровье',
    planets: [],
    text: 'Шестой дом в Тельце определяет ваш рабочий стиль как основательный, медленный, но невероятно продуктивный. Вы предпочитаете работать в комфортных условиях и не любите спешку. В здоровье обратите внимание на горло, щитовидную железу и обмен веществ. Вам полезны регулярные физические нагрузки и здоровое питание.',
  },
  {
    num: 7,
    sign: 'Близнецы',
    theme: 'Партнёрство и брак',
    planets: ['Марс'],
    text: 'Седьмой дом в Близнецах с Марсом — яркая и динамичная картина партнёрства. Вы ищете партнёра, который будет интеллектуально стимулировать вас. Марс здесь может давать конфликтность в отношениях: споры, дебаты, словесные перепалки. Но для вас это — форма близости. Скучный, молчаливый партнёр вам не подходит.',
  },
  {
    num: 8,
    sign: 'Рак',
    theme: 'Трансформация, чужие ресурсы',
    planets: ['Венера'],
    text: 'Восьмой дом в Раке с Венерой — глубокая тема. Вы трансформируетесь через любовь и эмоциональные кризисы. Чужие деньги (наследство, инвестиции, деньги партнёра) могут приходить к вам через семейные связи. Венера здесь даёт глубокую, почти мистическую сексуальность, связанную с эмоциональной близостью.',
  },
  {
    num: 9,
    sign: 'Лев',
    theme: 'Философия и путешествия',
    planets: ['Солнце', 'Меркурий'],
    text: 'Девятый дом в Льве с Солнцем и Меркурием — мощный стеллариум. Это ваш главный дом реализации. Вы находите себя через высшее образование, преподавание, путешествия, философию или издательскую деятельность. Вы — прирождённый наставник, гуру, эксперт. Ваша миссия — нести знания и вдохновение в мир.',
  },
  {
    num: 10,
    sign: 'Дева',
    theme: 'Карьера и статус',
    planets: ['Юпитер'],
    text: 'Десятый дом в Деве с Юпитером — отличная карьерная комбинация. Ваш социальный успех приходит через экспертность, служение и внимание к деталям. Юпитер расширяет возможности: вы можете достичь высокого положения в медицине, аналитике, IT, образовании или консалтинге. Ключ — сочетание масштабного видения (Юпитер) с безупречным качеством (Дева).',
  },
  {
    num: 11,
    sign: 'Весы',
    theme: 'Друзья и будущее',
    planets: [],
    text: 'Одиннадцатый дом в Весах говорит о том, что ваши друзья — это люди искусства, дипломатии и гармонии. Вы цените красивые, сбалансированные отношения в дружбе. Ваши мечты о будущем связаны с созданием справедливого, гармоничного мира. Вы можете быть активным участником общественных движений за равенство и красоту.',
  },
  {
    num: 12,
    sign: 'Скорпион',
    theme: 'Подсознание и духовность',
    planets: ['Луна', 'Плутон'],
    text: 'Двенадцатый дом в Скорпионе с Луной и Плутоном — самый мощный и загадочный сектор вашей карты. Здесь скрыта огромная психическая сила, которая работает на подсознательном уровне. Вы можете видеть пророческие сны, чувствовать энергетику мест и людей, обладать целительскими способностями. Но здесь же скрыты ваши глубочайшие страхи: страх потери контроля, предательства, смерти.',
  },
]

export const ASPECTS_DETAILED = [
  {
    planet1: 'Солнце',
    planet2: 'Меркурий',
    type: 'conjunction',
    symbol: '☌',
    nature: 'neutral' as const,
    title: 'Солнце ☌ Меркурий (Соединение)',
    text: 'Соединение Солнца и Меркурия во Льве создаёт мощный интеллектуально-творческий потенциал. Ваше мышление неотделимо от вашего эго — вы думаете «от себя» и «про себя». Это даёт убедительность речи и способность к самовыражению через слово, но может создавать субъективность и неспособность увидеть ситуацию глазами другого человека. Вы — блестящий оратор, писатель или преподаватель, способный зажечь аудиторию своими идеями.',
  },
  {
    planet1: 'Луна',
    planet2: 'Плутон',
    type: 'conjunction',
    symbol: '☌',
    nature: 'intense' as const,
    title: 'Луна ☌ Плутон (Соединение)',
    text: 'Это один из самых мощных аспектов в вашей карте. Соединение Луны и Плутона в Скорпионе в 12 доме создаёт невероятную эмоциональную глубину и психическую силу. Вы буквально «видите» людей насквозь. Ваша интуиция работает на уровне рентгена. Но этот же аспект может давать навязчивые эмоции, страх потери, потребность в контроле и склонность к эмоциональным манипуляциям (часто неосознанным). Проработка этого аспекта — ключ к вашей психологической свободе.',
  },
  {
    planet1: 'Солнце',
    planet2: 'Асцендент',
    type: 'trine',
    symbol: '△',
    nature: 'harmonious' as const,
    title: 'Солнце △ Асцендент (Трин)',
    text: 'Гармоничный аспект между вашим ядром личности (Солнце во Льве) и вашей социальной маской (Асц в Стрельце). Оба знака — огненные, что создаёт естественную цельность: то, что вы есть внутри, легко и органично проявляется вовне. Люди воспринимают вас как уверенного, харизматичного и искреннего человека. Вам не нужно «играть роль» — вы просто являетесь собой, и это работает.',
  },
  {
    planet1: 'Венера',
    planet2: 'Юпитер',
    type: 'sextile',
    symbol: '⚹',
    nature: 'harmonious' as const,
    title: 'Венера ⚹ Юпитер (Секстиль)',
    text: 'Аспект «малого и большого счастья». Венера (любовь, красота, деньги) в гармонии с Юпитером (удача, расширение, мудрость). Это даёт вам природное обаяние, хороший вкус, умение привлекать благоприятные обстоятельства и щедрость души. В финансах этот аспект может приносить удачу через социальные связи, партнёрства и творческие проекты.',
  },
  {
    planet1: 'Марс',
    planet2: 'Сатурн',
    type: 'square',
    symbol: '□',
    nature: 'tense' as const,
    title: 'Марс □ Сатурн (Квадрат)',
    text: 'Напряжённый аспект между вашей энергией действия (Марс в Близнецах) и внутренним цензором (Сатурн в Водолее). Вы можете чувствовать, что ваши действия постоянно блокируются, что вам не дают развернуться. Это создаёт внутреннее напряжение, которое может выражаться как раздражительность, подавленная агрессия или хроническая усталость. Проработка: научиться действовать дисциплинированно, но без самоподавления. Этот аспект даёт огромную выносливость и способность достигать целей через упорство.',
  },
  {
    planet1: 'Марс',
    planet2: 'Юпитер',
    type: 'square',
    symbol: '□',
    nature: 'tense' as const,
    title: 'Марс □ Юпитер (Квадрат)',
    text: 'Напряжение между действием и расширением. Вы склонны брать на себя слишком много, переоценивать свои силы и действовать слишком размашисто. Этот аспект даёт огромную энергию и авантюризм, но требует учиться чувству меры. Вы можете быть «вечным студентом», который начинает множество курсов и проектов, но не доводит их до конца.',
  },
  {
    planet1: 'Венера',
    planet2: 'Луна',
    type: 'trine',
    symbol: '△',
    nature: 'harmonious' as const,
    title: 'Венера △ Луна (Трин)',
    text: 'Прекрасный аспект эмоциональной гармонии. Ваши чувства (Луна) и ваши ценности в любви (Венера) находятся в согласии. Оба в водных знаках (Скорпион и Рак), что даёт глубокую эмоциональную чувствительность и способность к настоящей, глубокой любви. Вы умеете создавать атмосферу тепла и безопасности для близких людей.',
  },
]

export const HEALTH_SECTION = {
  overview: `Здоровье в натальной карте определяется комплексом факторов: положением Солнца (общая витальность), Луны (эмоциональное здоровье), 6-го дома (повседневное здоровье и привычки), Асцендента (физическое тело) и аспектов Марса (энергия и воспаление).`,

  sunHealth: `Солнце во Льве управляет сердцем, позвоночником и общей витальностью. Ваш запас жизненной энергии от природы высок, но вы склонны его растрачивать на «горение» — чрезмерную активность, стремление быть везде и всюду. Берегите сердце: как физически (кардионагрузки, контроль давления), так и эмоционально (не принимайте всё близко к сердцу).`,

  moonHealth: `Луна в Скорпионе связана с репродуктивной системой, выделительными органами и психосоматикой. Ваши эмоции напрямую влияют на тело. Подавленный гнев может проявляться как воспалительные процессы, проблемы с кожей или пищеварением. Важно не копить негативные эмоции — находите экологичные способы их выражения.`,

  sixthHouse: `Шестой дом в Тельце указывает на зоны внимания: горло, щитовидная железа, шея, обмен веществ. Вы можете быть склонны к набору веса, особенно в периоды стресса (Венера в Раке усиливает «заедание» эмоций). Регулярные физические нагрузки и осознанное питание — ваши главные инструменты здоровья.`,

  marsHealth: `Марс в Близнецах связан с нервной системой, руками, лёгкими и дыхательной системой. Вы можете быть склонны к нервному перенапряжению, бессоннице и тревожности. Дыхательные практики (пранаяма, холотропное дыхание) и работа руками (массаж, рукоделие, музыкальные инструменты) помогут сбалансировать эту энергию.`,

  recommendations: `• Кардионагрузки 3-4 раза в неделю (бег, плавание, велосипед)
• Дыхательные практики ежедневно (5-10 минут)
• Контроль питания: избегайте «заедания» стресса
• Регулярная проверка щитовидной железы
• Психотерапия или глубокие практики для проработки эмоций
• Достаточный сон (не менее 7-8 часов)
• Ограничение информационного потока (Марс в Близнецах перегружает нервную систему)`,
}

export const KARMIC_SECTION = {
  northNode: `Северный лунный узел в Стрельце (совпадает с вашим Асцендентом) — это мощный кармический указатель. Ваша задача в этой жизни — двигаться от детализации, анализа и критики (Южный узел в Близнецах) к масштабному видению, философии, вере и расширению горизонтов (Северный узел в Стрельце).

Это означает, что в прошлых жизнях (или в ранние годы этой жизни) вы были сосредоточены на сборе информации, общении, логике и рациональном мышлении. Теперь ваша задача — научиться доверять интуиции, видеть большую картину и делиться своей мудростью с миром.`,

  southNode: `Южный узел в Близнецах показывает ваши «кармические привычки» — то, что вам легко даётся, но что уже не служит вашему развитию. Это: поверхностное общение, сбор фактов без глубокого понимания, нервозность, рассеянность, склонность к сплетням или информационной перегрузке.

Марс на Южном узле (в 7 доме) добавляет кармическую тему конфликтов в партнёрстве. В прошлом вы могли быть склонны к словесным баталиям, манипуляциям через информацию или поверхностным отношениям. Ваша задача — перейти к глубоким, осмысленным партнёрствам, основанным на общих ценностях и философии.`,

  saturnLesson: `Сатурн в Водолее в 3 доме — ваш главный «учитель» в этой жизни. Урок: научиться структурировать свои идеи и нести ответственность за свои слова. В молодости вам могло быть сложно выражать свои мысли или вы чувствовали себя «белой вороной» среди сверстников. С возрастом вы становитесь всё более авторитетным интеллектуальным лидером.`,

  lifeMission: `Синтезируя все кармические показатели, ваша жизненная миссия — стать мудрым наставником, который сочетает глубокое знание (Скорпион, 12 дом) с яркой подачей (Лев, 9 дом) и практической пользой (Дева, 10 дом). Вы пришли в этот мир, чтобы трансформировать знания в мудрость и делиться ею с другими.`,
}

export const TALENTS_SECTION = {
  naturalAbilities: `На основе анализа вашей натальной карты можно выделить следующие природные таланты:

1. Ораторское искусство и преподавание (Солнце + Меркурий в Льве в 9 доме). Вы — прирождённый спикер, способный зажечь аудиторию.

2. Психологическая проницательность (Луна + Плутон в Скорпионе в 12 доме). Вы видите людей насквозь и понимаете скрытые мотивы.

3. Организаторские способности (Сатурн в Водолее, Юпитер в Деве). Вы умеете создавать эффективные системы и структуры.

4. Эмоциональный интеллект (Венера в Раке, Луна в Скорпионе). Вы глубоко чувствуете и понимаете эмоции — свои и чужие.

5. Стратегическое мышление (доминанта фиксированного креста). Вы способны удерживать долгосрочную цель и методично двигаться к ней.`,

  bestAreas: `Лучшие сферы для профессиональной реализации:
• Образование и наставничество (9 дом, Лев)
• Психология и психотерапия (12 дом, Скорпион)
• IT и системная аналитика (Сатурн в Водолее, Юпитер в Деве)
• Медицина и здоровье (6 дом в Тельце, 10 дом в Деве)
• Управление и лидерство (Солнце во Льве)
• Писательство и журналистика (Меркурий во Льве, Марс в Близнецах)
• Эзотерика и духовные практики (12 дом, Луна-Плутон)`,
}

export const CHALLENGES_SECTION = {
  mainChallenges: `Каждая натальная карта содержит не только таланты, но и вызовы — точки напряжения, которые требуют осознанной работы. Ваши главные вызовы:

1. Контроль и доверие. Луна-Плутон в 12 доме создаёт глубокий страх потери контроля и предательства. Вы можете неосознанно контролировать близких, что разрушает отношения. Урок: научиться доверять.

2. Гордость и уязвимость. Солнце во Льве не позволяет вам показывать слабость. Вы создаёте образ «сильного и успешного», но внутри можете страдать. Урок: позволить себе быть уязвимым.

3. Рассеивание энергии. Марс в Близнецах тянет вас в разные стороны одновременно. Вы можете начинать много дел и не доводить их до конца. Урок: фокус и приоритизация.

4. Эмоциональное «заедание». Венера в Раке + 6 дом в Тельце могут давать склонность к перееданию в стрессе. Урок: осознанное отношение к еде и телу.

5. Подавленная агрессия. Марс □ Сатурн создаёт внутренний конфликт между желанием действовать и внутренним цензором. Урок: найти здоровые способы выражения гнева.`,

  recommendations: `Рекомендации по работе с вызовами:
• Регулярная психотерапия (особенно глубинные методы: психоанализ, гештальт, EMDR)
• Практики осознанности и медитации
• Физическая активность для сброса напряжения
• Ведение дневника эмоций
• Работа с телом (массаж, йога, танцевально-двигательная терапия)
• Развитие навыка делегирования и доверия`,
}

export const FORECAST_SECTION = {
  overview: `Жизненные периоды определяются транзитами медленных планет и возвратами ключевых планет. Ниже — основные циклы вашей жизни.`,

  periods: [
    {
      age: '0–7 лет',
      title: 'Формирование эмоциональной базы',
      text: 'Период, когда закладываются основные эмоциональные паттерны. С Луной-Плутоном в 12 доме это могло быть время интенсивных, но скрытых переживаний. Возможно, в семье были секреты или эмоциональное напряжение, которое вы впитали на подсознательном уровне.',
    },
    {
      age: '7–14 лет',
      title: 'Развитие интеллекта и социализация',
      text: 'Активация 3 дома (Сатурн в Водолее). Возможные трудности в общении со сверстниками, ощущение «белой вороны». Но именно в этот период закладывается ваш уникальный интеллектуальный стиль.',
    },
    {
      age: '14–21 год',
      title: 'Поиск идентичности',
      text: 'Активация Солнца во Льве. Период яркого самовыражения, первых романов (Венера в Раке), творческих поисков. Возможны конфликты с авторитетами из-за сильного эго.',
    },
    {
      age: '21–29 лет',
      title: 'Построение карьеры и первый кризис',
      text: 'Период активного карьерного роста (Юпитер в 10 доме). Первый возврат Сатурна (~29 лет) — ключевой кризис взросления. Вы пересматриваете свои цели, отношения и жизненную философию. Это болезненный, но необходимый процесс.',
    },
    {
      age: '29–35 лет',
      title: 'Зрелость и трансформация',
      text: 'После возврата Сатурна начинается период настоящей зрелости. Вы обретаете уверенность в своей уникальности и начинаете строить жизнь на собственных условиях. Транзит Плутона может активировать глубокие трансформационные процессы.',
    },
    {
      age: '35–42 года',
      title: 'Расцвет и реализация',
      text: 'Период максимальной профессиональной реализации. Юпитер в 10 доме начинает приносить плоды. Вы становитесь признанным экспертом в своей области. Возможны значительные карьерные достижения и рост социального статуса.',
    },
    {
      age: '42–50 лет',
      title: 'Кризис середины жизни и духовный поиск',
      text: 'Оппозиция транзитного Урана к натальному (~42 года) и транзит Нептуна — период глубокого пересмотра жизненных ценностей. Вы можете обратиться к духовным практикам, сменить карьеру или кардинально изменить образ жизни. 12 дом (Луна-Плутон) активируется, требуя глубокой внутренней работы.',
    },
    {
      age: '50+ лет',
      title: 'Мудрость и наставничество',
      text: 'Второй возврат Сатурна (~58 лет) завершает цикл обучения. Вы становитесь мудрым наставником, способным передавать свой опыт следующим поколениям. 9 дом (Солнце, Меркурий) полностью раскрывается: преподавание, писательство, философия становятся вашим главным призванием.',
    },
  ],
}

export const FINAL_ANALYSIS = {
  summary: `Алексей, ваша натальная карта рисует портрет сложной, многогранной и невероятно глубокой личности. Вы — человек, в котором сочетаются огненная яркость Льва, водная глубина Скорпиона и философский размах Стрельца.

Ваша главная сила — это способность сочетать внешнюю харизму с внутренней глубиной. Вы можете быть одновременно ярким лидером на сцене и тонким психологом в кабинете. Вы видите людей насквозь, но умеете подать это знание с теплотой и юмором.

Ваш главный вызов — это интеграция противоположностей: свет и тень, контроль и доверие, независимость и привязанность. Когда вы научитесь принимать все части себя — и блестящего Льва, и тёмного Скорпиона, и свободного Стрельца — вы обретёте настоящую целостность.`,

  keyQualities: [
    'Природная харизма и лидерские качества',
    'Глубокая эмоциональная проницательность',
    'Интеллектуальная яркость и ораторский талант',
    'Невероятная стойкость и способность к возрождению',
    'Стратегическое мышление и долгосрочное видение',
    'Щедрость и способность вдохновлять других',
  ],

  lifeThemes: [
    'Самовыражение и творчество как путь к себе',
    'Глубокие трансформации через эмоциональные кризисы',
    'Поиск баланса между контролем и доверием',
    'Наставничество и передача знаний',
    'Интеграция света и тени в единое целое',
  ],

  finalAdvice: `Помните: натальная карта — это не приговор, а карта возможностей. Вы всегда свободны в своём выборе. Используйте это знание как компас, а не как ограничение. Ваш потенциал огромен — и только от вас зависит, насколько полно вы его реализуете.

Живите из сердца, доверяйте своей интуиции, не бойтесь глубины — и ваша жизнь станет тем великим приключением, для которого вы были рождены.`,
}

export const PLANET_POSITIONS_TABLE = [
  {
    planet: 'Солнце',
    symbol: '☉',
    sign: 'Лев',
    degree: "22° 34'",
    house: 9,
    dignity: 'Обитель',
  },
  {
    planet: 'Луна',
    symbol: '☽',
    sign: 'Скорпион',
    degree: "14° 18'",
    house: 12,
    dignity: 'Падение',
  },
  {
    planet: 'Меркурий',
    symbol: '☿',
    sign: 'Лев',
    degree: "18° 52'",
    house: 9,
    dignity: '—',
  },
  {
    planet: 'Венера',
    symbol: '♀',
    sign: 'Рак',
    degree: "8° 41'",
    house: 8,
    dignity: '—',
  },
  {
    planet: 'Марс',
    symbol: '♂',
    sign: 'Близнецы',
    degree: "15° 27'",
    house: 7,
    dignity: '—',
  },
  {
    planet: 'Юпитер',
    symbol: '♃',
    sign: 'Дева',
    degree: "3° 09'",
    house: 10,
    dignity: 'Изгнание',
  },
  {
    planet: 'Сатурн',
    symbol: '♄',
    sign: 'Водолей',
    degree: "17° 45'",
    house: 3,
    dignity: 'Обитель',
  },
  {
    planet: 'Уран',
    symbol: '♅',
    sign: 'Козерог',
    degree: "16° 33'",
    house: 2,
    dignity: '—',
  },
  {
    planet: 'Нептун',
    symbol: '♆',
    sign: 'Козерог',
    degree: "17° 21'",
    house: 2,
    dignity: '—',
  },
  {
    planet: 'Плутон',
    symbol: '♇',
    sign: 'Скорпион',
    degree: "20° 48'",
    house: 12,
    dignity: 'Обитель',
  },
]

export const ENERGY_RADAR_DATA = {
  axes: [
    {
      id: 'leadership',
      label: 'Лидерство',
      value: 85,
      description:
        'Солнце во Льве и Асцендент в Стрельце дают природную харизму и способность вести за собой.',
    },
    {
      id: 'intuition',
      label: 'Интуиция',
      value: 90,
      description:
        'Луна и Плутон в Скорпионе в 12 доме создают мощный интуитивный канал.',
    },
    {
      id: 'communication',
      label: 'Коммуникация',
      value: 75,
      description:
        'Меркурий во Льве даёт яркую речь, но Сатурн в 3 доме требует проработки.',
    },
    {
      id: 'stability',
      label: 'Стабильность',
      value: 80,
      description:
        'Доминанта фиксированного креста обеспечивает устойчивость и упорство.',
    },
    {
      id: 'creativity',
      label: 'Творчество',
      value: 88,
      description:
        'Солнце и Меркурий в 9 доме во Льве — мощный творческий потенциал.',
    },
    {
      id: 'depth',
      label: 'Глубина',
      value: 95,
      description:
        'Луна-Плутон в Скорпионе — одна из самых глубоких эмоциональных конфигураций.',
    },
  ],
}

export const ZODIAC_COMPATIBILITY = [
  {
    sign: 'Овен',
    symbol: '♈',
    percent: 72,
    note: 'Огненная энергия, но разные темпы',
  },
  {
    sign: 'Телец',
    symbol: '♉',
    percent: 65,
    note: 'Упрямство с обеих сторон',
  },
  {
    sign: 'Близнецы',
    symbol: '♊',
    percent: 78,
    note: 'Интеллектуальная связь, лёгкость',
  },
  {
    sign: 'Рак',
    symbol: '♋',
    percent: 85,
    note: 'Глубокая эмоциональная связь',
    best: true,
  },
  { sign: 'Лев', symbol: '♌', percent: 70, note: 'Борьба за лидерство' },
  {
    sign: 'Дева',
    symbol: '♍',
    percent: 75,
    note: 'Взаимодополнение в работе',
  },
  { sign: 'Весы', symbol: '♎', percent: 68, note: 'Красиво, но поверхностно' },
  {
    sign: 'Скорпион',
    symbol: '♏',
    percent: 92,
    note: 'Магнетическое притяжение',
    best: true,
  },
  {
    sign: 'Стрелец',
    symbol: '♐',
    percent: 88,
    note: 'Общие ценности и философия',
    best: true,
  },
  {
    sign: 'Козерог',
    symbol: '♑',
    percent: 73,
    note: 'Уважение и стабильность',
  },
  { sign: 'Водолей', symbol: '♒', percent: 76, note: 'Интеллектуальный союз' },
  { sign: 'Рыбы', symbol: '♓', percent: 82, note: 'Духовная связь и эмпатия' },
]

export const PERSONAL_AFFIRMATIONS = [
  {
    text: 'Я позволяю себе быть уязвимым — это моя настоящая сила',
    source: 'Луна в Скорпионе',
    icon: 'moon',
    gradient: 'from-indigo-50 to-slate-50',
  },
  {
    text: 'Мой свет не нуждается в чужом одобрении',
    source: 'Солнце во Льве',
    icon: 'sun',
    gradient: 'from-amber-50 to-slate-50',
  },
  {
    text: 'Я доверяю процессу и отпускаю контроль',
    source: 'Луна-Плутон в 12 доме',
    icon: 'sparkles',
    gradient: 'from-purple-50 to-slate-50',
  },
  {
    text: 'Каждый мой проект заслуживает завершения',
    source: 'Марс в Близнецах',
    icon: 'target',
    gradient: 'from-emerald-50 to-slate-50',
  },
  {
    text: 'Я выбираю глубину вместо поверхностности',
    source: 'Северный узел в Стрельце',
    icon: 'compass',
    gradient: 'from-rose-50 to-slate-50',
  },
  {
    text: 'Мои эмоции — мой компас, а не мой враг',
    source: 'Венера в Раке',
    icon: 'heart',
    gradient: 'from-pink-50 to-slate-50',
  },
]

export const CURRENT_TRANSITS = [
  {
    dateRange: '1-15 марта',
    transit: 'Юпитер трин натальное Солнце',
    nature: 'harmonious' as const,
    area: 'Карьера и самореализация',
    recommendation:
      'Отличное время для продвижения проектов и публичных выступлений. Удача на вашей стороне.',
  },
  {
    dateRange: '5-20 марта',
    transit: 'Сатурн квадрат натальный Марс',
    nature: 'tense' as const,
    area: 'Работа и энергия',
    recommendation:
      'Возможны задержки и препятствия. Проявите терпение, не форсируйте события.',
  },
  {
    dateRange: '10-25 марта',
    transit: 'Венера секстиль натальная Луна',
    nature: 'harmonious' as const,
    area: 'Отношения и эмоции',
    recommendation:
      'Гармония в личной жизни. Хорошее время для романтических встреч и семейных дел.',
  },
  {
    dateRange: '15-31 марта',
    transit: 'Меркурий соединение натальный Меркурий',
    nature: 'neutral' as const,
    area: 'Мышление и коммуникация',
    recommendation:
      'Ясность мышления, удачные переговоры. Подписывайте важные документы.',
  },
]

export const CELEBRITY_MATCHES = [
  {
    name: 'Барак Обама',
    initials: 'БО',
    sharedPlacement: 'Солнце во Льве, Асцендент в Водолее',
    note: 'Харизматичный лидер с глубоким стратегическим мышлением',
    color: 'bg-indigo-100 text-indigo-700',
  },
  {
    name: 'Леонардо Ди Каприо',
    initials: 'ЛД',
    sharedPlacement: 'Солнце в Скорпионе (близко к вашей Луне)',
    note: 'Интенсивность и способность к перевоплощению',
    color: 'bg-amber-100 text-amber-700',
  },
  {
    name: 'Мадонна',
    initials: 'М',
    sharedPlacement: 'Солнце во Льве, Луна в Деве',
    note: 'Неукротимая воля к самовыражению и перфекционизм',
    color: 'bg-rose-100 text-rose-700',
  },
  {
    name: 'Фёдор Достоевский',
    initials: 'ФД',
    sharedPlacement: 'Солнце в Скорпионе, Меркурий во Льве',
    note: 'Глубина психологического анализа и яркость слова',
    color: 'bg-emerald-100 text-emerald-700',
  },
]

export const NATAL_CHART_VISUAL = {
  signs: [
    { name: 'Овен', symbol: '♈', startDeg: 0, color: '#ef4444' },
    { name: 'Телец', symbol: '♉', startDeg: 30, color: '#22c55e' },
    { name: 'Близнецы', symbol: '♊', startDeg: 60, color: '#eab308' },
    { name: 'Рак', symbol: '♋', startDeg: 90, color: '#6366f1' },
    { name: 'Лев', symbol: '♌', startDeg: 120, color: '#f97316' },
    { name: 'Дева', symbol: '♍', startDeg: 150, color: '#84cc16' },
    { name: 'Весы', symbol: '♎', startDeg: 180, color: '#ec4899' },
    { name: 'Скорпион', symbol: '♏', startDeg: 210, color: '#8b5cf6' },
    { name: 'Стрелец', symbol: '♐', startDeg: 240, color: '#f43f5e' },
    { name: 'Козерог', symbol: '♑', startDeg: 270, color: '#64748b' },
    { name: 'Водолей', symbol: '♒', startDeg: 300, color: '#06b6d4' },
    { name: 'Рыбы', symbol: '♓', startDeg: 330, color: '#a855f7' },
  ],
  planets: [
    { symbol: '☉', name: 'Солнце', degree: 142, sign: 'Лев' },
    { symbol: '☽', name: 'Луна', degree: 224, sign: 'Скорпион' },
    { symbol: '☿', name: 'Меркурий', degree: 138, sign: 'Лев' },
    { symbol: '♀', name: 'Венера', degree: 98, sign: 'Рак' },
    { symbol: '♂', name: 'Марс', degree: 75, sign: 'Близнецы' },
    { symbol: '♃', name: 'Юпитер', degree: 153, sign: 'Дева' },
    { symbol: '♄', name: 'Сатурн', degree: 317, sign: 'Водолей' },
    { symbol: '♅', name: 'Уран', degree: 286, sign: 'Козерог' },
    { symbol: '♆', name: 'Нептун', degree: 287, sign: 'Козерог' },
    { symbol: '♇', name: 'Плутон', degree: 230, sign: 'Скорпион' },
  ],
  ascendant: { degree: 240, sign: 'Стрелец' },
}
